const errorInfos = [
  `\npath:${window?.location?.pathname}`,
  `\nurl:${window?.location?.href}`
]
export const logErr = (logs) =>
  console.error.apply(null, ['【$dict】', ...logs, ...errorInfos])
